import { useWSSnackbar } from "@wingspanhq/fe-component-library";
import { queriesPayees } from "@query";
import { useXWingspanPayerId } from "../routes/RoutePayeeDetails/useXWingspanPayerId";

/**
 * Resends the Wingspan invite to a payee (contractor). v3 has no dedicated
 * resend endpoint — re-calling `invitePayee` re-issues the invite, so this wraps
 * the registry mutation and keeps the v1 `(payeeId) => Promise` call signature so
 * consumers swap only the import.
 *
 * Org/expansion context: v1 sent the org's id via the `X-Wingspan-User` header;
 * the v3 equivalent is the `xWingspanAccount` request scope (relies on the
 * D1/D24 `userId == accountId` equivalence — see MIGRATION.md).
 */
export const useResendPayeeInvite = () => {
  const { openSnackbar } = useWSSnackbar();
  const xWingspanAccount = useXWingspanPayerId();

  const [invitePayee, meta] = queriesPayees.invitePayee.useMutation({
    onSuccess: () => {
      openSnackbar({
        message: "Invitation email resent to contractor",
        type: "success"
      });
    },
    onError: () => {
      openSnackbar({
        message: "Failed to send invitation to contractor",
        type: "error"
      });
    }
  });

  const resendInvite = (payeeId: string) =>
    invitePayee({ payeeId, xWingspanAccount });

  return [resendInvite, meta] as const;
};
